<template>
    <div class="order-status" :class="{show: showMultipleInfo}" @click.stop="showMultiple">
        <div class="multiple order" v-if="isMultiple" @click.stop="showMultiple">
            <img src="@/assets/img/warning.svg">
            您有多筆通知 <img src="@/assets/img/next-white.svg">
        </div>
        <div class="dispatching order" v-if="isDispatching && !isMultiple" @click.stop="goToTimeline">
            <img src="@/assets/img/mate.svg">
            配對中
            <span>任務#{{ order.id }}</span>
        </div>
        <div class="missing order" v-if="isMessing && !isMultiple" @click.stop="goToTimeline">
            <img src="@/assets/img/warning.svg">
            暫停配對
            <span>請點擊查看</span><img src="@/assets/img/next-white.svg">
        </div>
        <div class="processing order" v-if="isWaitGoLocation && !isMultiple" @click.stop="goToTimeline">
            <img src="@/assets/img/success-broder.svg">
            預約成功
            <span>{{ waitMsg }}</span>
        </div>
        <div class="processing order" v-if="isProcessing && !isWaitGoLocation && !isMultiple" @click.stop="goToTimeline">
            <img src="@/assets/img/run.svg">
            執行中
            <span v-show="! location.arrived_at">前往</span>
            <span v-show="location.arrived_at">抵達</span>
            <div>{{ location.alias || location.road }}</div>
        </div>
        <div class="debt order" v-if="isDebt && !isMultiple" @click.stop="goToOrder">
            <img src="@/assets/img/warning.svg">
            您尚有欠款
            <span>請點擊前往繳費</span><img src="@/assets/img/next-white.svg">
        </div>
        <div class="info missing order" v-if="!canOrder && isWork && !isMultiple">
            <img src="@/assets/img/warning.svg">
            休息中
            <span>服務時間： {{ enableHour | timeFormat }}:{{ enableMin | timeFormat }} ~ {{ unableHour | timeFormat }}:{{ unableMin | timeFormat }}</span>
        </div>
        <div class="info missing order" v-if="!isWork && !isMultiple">
            <img src="@/assets/img/warning.svg">
            {{ notWorkContent }}
        </div>
        <div class="debt order" v-if="socketState !== 'connected'">
            連線異常，請確認網路並重新整理頁面
        </div>
        <div class="multiple-info" :style="multipleInfo" @click.stop>
            <div class="title">多筆通知</div>
            <div class="subtitle">任務狀態</div>
            <status-item v-for="item in ordersSort" :key="item.id" :order="item" @onClose="showMultipleInfo = false"/>
            <div class="subtitle" v-if="(!canOrder && isWork) || !isWork">平台公告</div>
            <div class="info-item" v-if="!canOrder && isWork">
                <img src="@/assets/img/warning.svg">
                休息中
                <span>服務時間： {{ enableHour | timeFormat }}:{{ enableMin | timeFormat }} ~ {{ unableHour | timeFormat }}:{{ unableMin | timeFormat }}</span>
            </div>
            <div class="info-item" v-if="!isWork">
                <div class="info missing order" v-if="!isWork">
                    <img src="@/assets/img/warning.svg">
                    {{ notWorkContent }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import OrderStatusItem from "./list/OrderStatusItem";
    import * as R from 'ramda';

    export default {
        name: 'OrderStatus',
        components: {
           'status-item': OrderStatusItem,
        },
        data() {
            return {
                showMultipleInfo: false,
            };
        },
        computed: {
            ordersSort() {
                return R.sort((o1, o2) => {
                    if (o1.status === 'processing' && o2.status === 'processing') {
                        if (o1.reserved_at == null) return -1;
                        if (o2.reserved_at == null) return 1;
                        return 0;
                    }
                    if (o1.status === 'processing') return -1;
                    if (o2.status === 'processing') return 1;
                    if (o1.status === 'dispatching' || o1.status === 'sending' || o1.status === 'appointing') return -1;
                    if (o2.status === 'dispatching' || o2.status === 'sending' || o2.status === 'appointing') return 1;
                    if (o1.status === 'missing') return -1;
                    if (o2.status === 'missing') return 1;

                    return 0;
                }, this.processing);
            },
            multipleInfo() {
                let height = '0';
                let padding = '0';
                let maxHeight = '0';
                if (this.showMultipleInfo) {
                    height = 'auto';
                    padding = '15px';
                    maxHeight = '800px';
                }

               return {
                   'height': height,
                   'padding': padding,
                   'max-height': maxHeight,
               };
            },
            isMultiple() {
                let count = this.processing.length;
                if (!this.isWork) count++;
                if (!this.canOrder && this.isWork) count++;

                return count > 1;
            },
            isDispatching() {
                return this.order.status === 'dispatching' || this.order.status === 'sending' || this.order.status === 'appointing';
            },
            isMessing() {
                return this.order.status === 'missing';
            },
            isWaitGoLocation() {
                return this.order.status === 'processing' && this.order.reserved_at && ! this.order.locations[0].arrived_at;
            },
            waitMsg() {
                if (! this.order.reserved_at) {
                    return '';
                }

                let reservedAt = moment(this.order.reserved_at);
                let day = reservedAt.format('MM/DD');
                let time = reservedAt.format('HH:mm');
                if (moment().isSame(reservedAt, 'day')) {
                    day = '今日';
                }

                return `將於 ${day} ${time} 開始執行`;
            },
            isProcessing() {
                return this.order.status === 'processing';
            },
            isDebt() {
                return this.order.is_debt;
            },
            location() {
                return this.order.locations.find(location => !location.arrived_at || !location.left_at);
            },
            order() {
                if (! this.processing.length) {
                    return {
                        status: '',
                        locations: [],
                        is_debt: false,
                    };
                }

                return this.processing[0];
            },
            ...mapGetters(['processing', 'canOrder', 'isWork', 'notWorkContent', 'enableHour', 'enableMin', 'unableHour', 'unableMin', 'socketState'])
        },
        methods: {
            goToTimeline() {
                this.$router.push({
                    name: 'timeline',
                    params: {
                        id: this.order.id,
                    },
                })
            },
            goToOrder() {
                this.$router.push({
                    name: 'order',
                    params: {
                        id: this.order.id,
                    }
                })
            },
            showMultiple() {
                this.showMultipleInfo = !this.showMultipleInfo;
            }
        },
        filters: {
            timeFormat(value) {
                value = String(value);
                if (value.length < 2) {
                    value = '0' + value;
                }

                return value;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .order-status {

        &.show {
            position: absolute;
            width: 100%;
            z-index: 9999;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            background-color: rgba(0,0,0,0.4);
        }

        .multiple-info {
            border-radius: 0 0 10px 10px;
            max-height: 0;
            overflow: hidden;
            transition: max-height .5s ease-in-out;
            background-color: white;

            .title {
                margin-top: 10px;
                color: #000000;
                font-size: 16px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 22px;
                text-align: center;
                cursor: default;
                user-select: none;
            }

            .subtitle {
                margin-top: 25px;
                margin-left: 10px;
                color: #9B9B9B;
                font-size: 13px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 18px;
                text-align: left;
                cursor: default;
                user-select: none;
            }

            .info-item {
                border-radius: 4px;
                height: 35px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                padding-left: 25px;
                overflow: hidden;
                color: #FFFFFF;
                font-size: 16px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 22px;
                white-space: nowrap;
                cursor: pointer;
                box-shadow: 0 1px 3px 0 rgba(0,0,0,0.15);
                margin-top: 5px;
                background-color: #F1A226;

                span {
                    margin-left: 15px;
                    color: #FFFFFF;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 20px;
                }

                div {
                    margin-left: 5px;
                    color: #FFFFFF;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 20px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                img {
                    margin-right: 5px;
                }
            }
        }

        .order {
            height: 35px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding-left: 25px;
            overflow: hidden;
            color: #FFFFFF;
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 22px;
            white-space: nowrap;
            cursor: pointer;

            span {
                margin-left: 15px;
                color: #FFFFFF;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 20px;
            }

            div {
                margin-left: 5px;
                color: #FFFFFF;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            img {
                margin-right: 5px;
            }
        }

        .multiple {
            background: linear-gradient(282deg, #e05e00, #fdd442, #e05e00, #fdd442);
            background-size: 400% 400%;
            animation: ani1 1.8s infinite linear;
        }

        .dispatching {
            background: linear-gradient(282deg, #69ACFA, #2E72C2, #69ACFA, #2E72C2);
            background-size: 400% 400%;
            animation: ani1 1.8s infinite linear;
        }

        .processing {
            background: linear-gradient(282deg, #36B736, #2D6C2D, #36B736, #2D6C2D);
            background-size: 400% 400%;
            animation: ani1 1.8s infinite linear;

            span {
                font-size: 12px !important;
                line-height: 17px !important;
            }
        }

        .missing {
            background: linear-gradient(282deg, #999999, #4d4d4d, #999999, #4d4d4d);
            background-size: 400% 400%;
            animation: ani1 1.8s infinite linear;
        }

        .debt {
            background: linear-gradient(282deg, #D82013, #FF695E, #D82013, #FF695E);
            background-size: 400% 400%;
            animation: ani1 1.8s infinite linear;
        }
    }

    @keyframes ani1 {
        0% {
            background-position:0% 75%;
        }
        100% {
            background-position:100% 25%;
        }
    }
</style>
